<template>
  <div
    class="sf-collected-product"
    :class="{ 'bundle-rz': type === 'bundle' }"
  >
    <div class="sf-collected-product__main">
      <div class="sf-collected-product__details">
        <slot name="title" v-bind="{ title }">
          <div class="sf-collected-product__title-wraper">
            <SfLink :link="link" class="sf-collected-product__title">
              {{ title }}
            </SfLink>
          </div>
        </slot>

        <slot name="configuration" />

        <div class="sf-collected-product__remove-wrapper">
          <slot name="remove" v-bind="{ removeHandler }">
            <SfCircleIcon
              icon="cross"
              aria-label="Remove"
              class="sf-circle-icon--small sf-collected-product__remove sf-collected-product__remove--circle-icon"
            />
            <SfButton
              class="sf-button--text sf-collected-product__remove sf-collected-product__remove--text"
              @click="removeHandler"
            >
              Remove
            </SfButton>
          </slot>
        </div>

        <div class="sf-collected-product__actions">
          <slot name="actions" />
        </div>
      </div>

      <div
        class="sf-collected-product__qty"
        v-if="type !== 'bundle'"
      >
        <slot name="input">
          <div class="sf-collected-product__quantity-wrapper">
            <SfQuantitySelector
              :qty="qty"
              :max="maxQuantity > 0 ? maxQuantity : undefined"
              class="sf-collected-product__quantity-selector"
              @input="onQuantityInput"
            />
            <a-product-unit :product="this" :unit="sellingUnit" :qty="qty" />
          </div>
        </slot>
      </div>

      <div class="sf-collected-product__price">
        <slot name="price" v-bind="{ specialPrice, regularPrice }">
          <SfPrice
            v-if="regularPrice"
            :regular="regularPrice"
            :special="specialPrice"
          />
        </slot>
      </div>
    </div>

    <div class="sf-collected-product__aside">
      <slot name="image" v-bind="{ image, title }">
        <SfImage
          :src="image"
          :alt="title"
          :width="imageWidth"
          :height="imageHeight"
          class="sf-collected-product__image"
        />
      </slot>
    </div>

    <slot name="more-actions">
      <SfButton
        aria-label="More actions"
        class="sf-button--pure sf-collected-product__more-actions mobile-only"
      >
        <SfIcon icon="more" />
      </SfButton>
    </slot>
  </div>
</template>

<script>
import {
  SfPrice,
  SfIcon,
  SfImage,
  SfCircleIcon,
  SfButton,
  SfQuantitySelector,
  SfLink
} from '@storefront-ui/vue';
import AProductUnit from 'theme/components/atoms/a-product-unit'

export default {
  name: 'SfCollectedProduct',
  components: {
    SfButton,
    SfIcon,
    SfImage,
    SfCircleIcon,
    SfPrice,
    SfQuantitySelector,
    SfLink,
    AProductUnit
  },
  model: {
    prop: 'qty'
  },
  props: {
    /**
     * Product image
     * It should be an url of the product
     */
    image: {
      type: [String, Object],
      default: ''
    },
    /**
     * Product image width, without unit
     */
    imageWidth: {
      type: [String, Number],
      default: 140
    },
    /**
     * Product image height, without unit
     */
    imageHeight: {
      type: [String, Number],
      default: 200
    },
    /**
     * Product title
     */
    title: {
      type: String,
      default: ''
    },
    /**
     * Product regular price
     */
    regularPrice: {
      type: [Number, String],
      default: null
    },
    /**
     * Product special price
     */
    specialPrice: {
      type: [Number, String],
      default: null
    },
    /**
     * Selected quantity
     */
    qty: {
      type: [Number, String],
      default: 1
    },
    /**
     * Link to product
     */
    link: {
      type: [String, Object],
      default: ''
    },
    /**
     * Product type_id
     */
    type: {
      type: String,
      default: ''
    },
    sellingUnit: {
      type: Number,
      default: null
    },
    maxQuantity: {
      type: Number,
      default: 0
    }
  },
  methods: {
    removeHandler () {
      this.$emit('click:remove');
    },
    onQuantityInput (value) {
      let next = parseInt(value, 10)
      if (!Number.isFinite(next) || next < 1) next = 1
      if (this.maxQuantity > 0 && next > this.maxQuantity) {
        next = this.maxQuantity
      }
      if (next === parseInt(this.qty, 10)) return
      this.$emit('input', next)
    }
  }
};
</script>
<style lang="scss">
@import "~@storefront-ui/shared/styles/components/organisms/SfCollectedProduct.scss";
</style>
